import { Modal as BaseModal } from "antd";

import "./Modal.style.less";

const Modal = (modalProps) => (
  <BaseModal wrapClassName="stelar-modal" {...modalProps} />
);

export default Modal;
